export default "__VITE_ASSET__8824a26d__"